<template>
  <div class="wrapper">
    <promo-modal />
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/jgestates-services-1.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h1 class="title">Services</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="projects-5">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">We're here to make your life as a Landlord an ease</h2>
              <h4 class="description">
                Check out our services listed below. We also offer <span style="font-weight: 400;">eviction support</span> so feel free to drop us a message if you would like assistance.
              </h4>
              <div class="section-space"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 ml-auto">
              <card
                type="background"
                raised
                class="card-background-product"
                style="background-image: url('img/jgestates-services-2.jpg')"
              >
                <h2 class="card-title">Tenant Find Service</h2>
                <p class="card-description">
                  Are you looking for us to simply find you a suitable tenant for your property?
                </p>
                <p class="card-description">
                  Use our Tenant Find Service with a one-off payment of only £450
                </p>
              </card>
            </div>
            <div class="col-md-5 mr-auto">
              <info-section
                type="primary"
                icon="now-ui-icons ui-1_check"
                title="Fully vetted tenants"
                description="Tenants are fully vetted to set criteria to guarantee authenticity and all details provided by them"
              />

              <info-section
                type="primary"
                icon="now-ui-icons education_agenda-bookmark"
                title="Legal cover"
                description="We legally cover you if you have any problems with tenants in the first 12 months"
              />

              <info-section
                type="primary"
                icon="now-ui-icons files_paper"
                title="Paperwork and contracts"
                description="We will complete all relevant paperwork and contracts and forward to landlord"
              />
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-5 ml-auto mt-5">
              <info-section
                type="primary"
                icon="now-ui-icons users_single-02"
                title="Tenant Find Service"
                description="Includes the JG Estates Tenant Find Service"
              />

              <info-section
                type="primary"
                icon="now-ui-icons education_agenda-bookmark"
                title="Legal cover"
                description="We legally cover landlords if problems arise at any point during tenancy"
              />

              <info-section
                type="primary"
                icon="now-ui-icons files_single-copy-04"
                title="Property inventory"
                description="The property is fully audited to capture all items that make up the inventory"
              />

              <info-section
                type="primary"
                icon="now-ui-icons business_bank"
                title="Rent-loss protection"
                description="We guarantee that you will not lose out on any rent if tenants do not pay"
              />

              <info-section
                type="primary"
                icon="now-ui-icons shopping_delivery-fast"
                title="Free eviction service"
                description="Free eviction service should tenants cause any issues"
              />

            </div>
            <div class="col-md-5 mr-auto">
              <card
                type="background"
                raised
                class="card-background-product"
                style="background-image: url('img/jgestates-services-1.jpg')"
              >
                <h2 class="card-title">Fully Managed Service</h2>
                <p class="card-description text-white">
                  Want us to take care of everything from finding suitable tenants to maintaining a hassle-free experience as a Landlord? Our Fully Managed Service is the ideal service for you
                </p>
              </card>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="about-team team-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">We are nerd rockstars</h2>
              <h4 class="description">
                This is the paragraph where you can write more details about
                your team. Keep you user engaged by providing meaningful
                information.
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-7 ml-auto mr-auto">
              <card type="profile" plain>
                <div slot="raw-content" class="row">
                  <div class="col-md-5">
                    <div class="card-image">
                      <a href="#pablo">
                        <img
                          class="img img-raised rounded"
                          src="img/olivia.jpg"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="card-body">
                      <h4 class="card-title">Ella Evelyn</h4>
                      <h6 class="category">Air Crew Member</h6>
                      <p class="card-description">
                        Think in the morning. Act in the noon. Eat in the
                        evening. Sleep in the night......
                      </p>
                      <div class="card-footer">
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-twitter"
                          ><i class="fab fa-twitter"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-facebook"
                          ><i class="fab fa-facebook-square"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-google"
                          ><i class="fab fa-google"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-xl-6 col-lg-7 ml-auto mr-auto">
              <card type="profile" plain>
                <div slot="raw-content" class="row">
                  <div class="col-md-5">
                    <div class="card-image">
                      <a href="#pablo">
                        <img
                          class="img img-raised rounded"
                          src="img/emily.jpg"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="card-body">
                      <h4 class="card-title">Mila Skylar</h4>
                      <h6 class="category">Architect</h6>
                      <p class="card-description">
                        Love cures people - both the ones who give it and the
                        ones who receive it...
                      </p>
                      <div class="card-footer">
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-linkedin"
                          ><i class="fab fa-linkedin"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-facebook"
                          ><i class="fab fa-facebook-square"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-dribbble"
                          ><i class="fab fa-dribbble"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-google"
                          ><i class="fab fa-google"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-xl-6 col-lg-7 ml-auto mr-auto">
              <card type="profile" plain>
                <div slot="raw-content" class="row">
                  <div class="col-md-5">
                    <div class="card-image">
                      <a href="#pablo">
                        <img
                          class="img img-raised rounded"
                          src="img/james.jpg"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="card-body">
                      <h4 class="card-title">Daniel Carter</h4>
                      <h6 class="category">Aviation Inspector</h6>
                      <p class="card-description">
                        Keep your face always toward the sunshine - and shadows
                        will fall behind you...
                      </p>
                      <div class="card-footer">
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-youtube"
                          ><i class="fab fa-youtube"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-twitter"
                          ><i class="fab fa-twitter"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-instagram"
                          ><i class="fab fa-instagram"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-xl-6 col-lg-7 ml-auto mr-auto">
              <card type="profile" plain>
                <div slot="raw-content" class="row">
                  <div class="col-md-5">
                    <div class="card-image">
                      <a href="#pablo">
                        <img
                          class="img img-raised rounded"
                          src="img/michael.jpg"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="card-body">
                      <h4 class="card-title">Dylan Wyatt</h4>
                      <h6 class="category">Conservation Scientist</h6>
                      <p class="card-description">
                        There is only one corner of the universe you can be
                        certain of improving, and that's your own self...
                      </p>
                      <div class="card-footer">
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-linkedin"
                          ><i class="fab fa-linkedin"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-facebook"
                          ><i class="fab fa-facebook-square"></i
                        ></a>
                        <a
                          href="#pablo"
                          class="btn btn-icon btn-neutral btn-google"
                          ><i class="fab fa-google"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox,
} from "@/components";
import { Select, Option } from "element-ui";
import PromoModal from "../components/Customised/PromoModal.vue";

export default {
  name: "about-us",
  bodyClass: "about-us",
  components: {
    Card,
    InfoSection,
    Badge,
    PromoModal,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: "",
      },
    };
  },
};
</script>

<style scoped>
</style>
